import React from 'react';
import Layout from '../Maker.layout';
import { useOption, worksheetActions } from '@src/stores/worksheet.store';
import ToggleSwitch from '@src/components/UI/Switch';

const Wrapper = ({ children }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 10,
      }}
    >
      {children}
    </div>
  );
};

const Options = () => {
  // categories
  const area = useOption('area');
  const subtopic = useOption('subtopic');
  const difficulty = useOption('difficulty');
  const series = useOption('series');
  const paper = useOption('paper');

  // qr code options
  const questionMsQR = useOption('questionMsQR');
  const questionWrittenMsQR = useOption('questionWrittenMsQR');
  const writtenMsQR = useOption('writtenMsQR');

  // misc
  const markSchemePDF = useOption('markSchemePDF');

  return (
    <Layout>
      <div>
        <h4>Question Pdf</h4>
        <hr />

        <p>
          <strong>Categories</strong>
        </p>

        <Wrapper>
          <p>Area(s)</p>
          <ToggleSwitch
            id="area"
            checked={area}
            onChange={() => worksheetActions.toggleOption('area')}
          />
        </Wrapper>

        <Wrapper>
          <p>Subtopic(s)</p>
          <ToggleSwitch
            id="subtopic"
            checked={subtopic}
            onChange={() => worksheetActions.toggleOption('subtopic')}
          />
        </Wrapper>

        <Wrapper>
          <p>Difficulty</p>
          <ToggleSwitch
            id="difficulty"
            checked={difficulty}
            onChange={() => worksheetActions.toggleOption('difficulty')}
          />
        </Wrapper>

        <Wrapper>
          <p>Series</p>
          <ToggleSwitch
            id="series"
            checked={series}
            onChange={() => worksheetActions.toggleOption('series')}
          />
        </Wrapper>

        <Wrapper>
          <p>Paper</p>
          <ToggleSwitch
            id="paper"
            checked={paper}
            onChange={() => worksheetActions.toggleOption('paper')}
          />
        </Wrapper>
      </div>

      <div>
        <p>
          <strong>QR Codes</strong>
        </p>

        <Wrapper>
          <p>Include Mark Scheme</p>
          <ToggleSwitch
            id="questionMsQR"
            checked={questionMsQR}
            onChange={() => worksheetActions.toggleOption('questionMsQR')}
          />
        </Wrapper>

        <Wrapper>
          <p>Include Written MS</p>
          <ToggleSwitch
            id="questionWrittenMsQR"
            checked={questionWrittenMsQR}
            onChange={() => worksheetActions.toggleOption('questionWrittenMsQR')}
          />
        </Wrapper>
      </div>

      <div>
        <h4>Mark Scheme Pdf</h4>
        <hr />

        <Wrapper>
          <p>Include Separate Mark Scheme PDF</p>
          <ToggleSwitch
            id="markSchemePDF"
            checked={markSchemePDF}
            onChange={() => worksheetActions.toggleOption('markSchemePDF')}
          />
        </Wrapper>

        <Wrapper>
          <p>Include Written MS QR Code</p>
          <ToggleSwitch
            id="writtenMsQR"
            checked={writtenMsQR}
            onChange={() => worksheetActions.toggleOption('writtenMsQR')}
          />
        </Wrapper>
      </div>
    </Layout>
  );
};

export default Options;
